import { createPinia } from "pinia"
import { markRaw } from "vue"
import router from "@/router/index.js"

export const pinia = createPinia()

pinia.use(({ store }) => {
  store.router = markRaw(router)
})

pinia.use(({ store }) => {
  store.$onAction(({ store, name, args, after, onError }) => {
    console.log(`🛫 [${store.$id}] action ${name} called with args:`, JSON.stringify(args))

    after((result) => {
      console.log(`⌛ [${store.$id}] action ${name} returned ${JSON.stringify(result)}`)
    })

    onError((error) => {
      console.error(`🚨 [${store.$id}] action ${name} failed with ${error}`)
    })
  })
})
